export default "__VITE_ASSET__CgJwNywi__"